import React from "react";
import numeral from "numeral";
import { withTranslation } from "react-i18next";
import TimeHelper from "util/TimeHelper";
class CounterRate extends React.Component {
  constructor(props) {
    super(props);
    this._checkPrevMetric = () => this.state.prevMetric && this.state.prevMetric.count !== void 0 && this.state.prevTs;
    this._placeholder = () => {
      if (this.props.hideOnZero) {
        return null;
      }
      return /* @__PURE__ */ React.createElement("span", null, this._prefix(), this.props.t("counter_rate.calculating"));
    };
    this._prefix = () => {
      if (this.props.prefix) {
        return `${this.props.prefix} `;
      }
      return null;
    };
    this._suffix = () => {
      const suffix = this.props.suffix === void 0 ? this.props.t("counter_rate.per_second") : this.props.suffix;
      if (suffix) {
        return ` ${suffix}`;
      }
      return null;
    };
    this.state = {
      prevMetric: null,
      prevTs: null,
      nowTs: TimeHelper.nowInSeconds()
    };
  }
  UNSAFE_componentWillReceiveProps() {
    this.setState({
      prevMetric: this.props.metric,
      prevTs: this.state.nowTs,
      nowTs: TimeHelper.nowInSeconds()
    });
  }
  render() {
    if (!(this.props.metric && this.props.metric.count !== void 0)) {
      if (this.props.hideOnMissing) {
        return null;
      }
      if (!this._checkPrevMetric()) {
        return this._placeholder();
      }
    }
    const { count } = this.props.metric;
    let rate = null;
    if (this._checkPrevMetric()) {
      const rateNum = (count - this.state.prevMetric.count) / (this.state.nowTs - this.state.prevTs);
      rate = /* @__PURE__ */ React.createElement("span", { key: "rate", className: "number-format" }, this._prefix(), numeral(rateNum).format("0,0"), this._suffix());
    } else {
      return this._placeholder();
    }
    if (this.props.hideOnMissing && !rate) {
      return null;
    }
    return /* @__PURE__ */ React.createElement("span", null, rate, this.props.showTotal && /* @__PURE__ */ React.createElement("span", { key: "absolute", className: "number-format" }, " ", this.props.t("counter_rate.total", { total: numeral(count).format("0") })));
  }
}
CounterRate.defaultProps = {
  showTotal: false,
  prefix: null,
  hideOnZero: false,
  hideOnMissing: false,
  metric: void 0
};
export default withTranslation("system")(CounterRate);
